import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Fab from "@mui/material/Fab";
import { Typography, Link, Chip } from "@mui/material";
import Divider from '@mui/material/Divider';
import './ProtectedHelp.scss';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from "@mui/material/Box";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Cookie, DisabledByDefault } from "@mui/icons-material";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import BlockIcon from '@mui/icons-material/Block';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import FeedIcon from '@mui/icons-material/Feed';
import HistoryIcon from '@mui/icons-material/History';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
const ProtectedHelp = () => {
  /**
   * This method is used to download the PDF document
   */

  const [value, setValue] = useState("overview")
  const [subTabValue, setSubTabValue] = useState("overview")
  const [mainTab, setMainTab] = useState("userManual");
  const location = useLocation();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const tab = urlParams.get('tab');
    if (tab === 'releaseNotes') {
      setMainTab('releaseNotes');
    }
  }, [location]);

  const handleDownload = () => {
    const filePath = "/assets/OLM For SFTP.pdf";

    const link = document.createElement("a");
    link.href = filePath;
    link.setAttribute("download", "OLM For SFTP.pdf");
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
  };

  function handleChange(eve, val) {
    setValue(val)
  }

  function subMenuSelect(event, val) {
    setSubTabValue(val)

  }

  const handleMainTabChange = (event, newValue) => {
    setMainTab(newValue);
  };

  return (
    <>
      <div className="helpSectionContainer">
        <div className="helpSectionContent">
          <Tabs
            value={mainTab}
            onChange={handleMainTabChange}
            aria-label="main tabs example"
          >
            <Tab value="userManual" label="User Manual" />
            <Tab value="releaseNotes" label="Release Notes" />
          </Tabs>
          {mainTab === "userManual" && (
            <Box my={2}>
              {/* <Typography variant="h6" my={1}>
                User Manual
              </Typography> */}
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="secondary tabs example"
              >
                <Tab value="overview" label="Overview" />
                <Tab value="job" label="Job Management" />
                <Tab value="cloudStorage" label="Cloud Storage" />
                <Tab value="apiRetrieval" label="API Retrieval" />
                <Tab value="settings" label="Settings" />
                <Tab value="serverManagement" label="Server Management" />
                <Tab value="install" label="Installation Guide" />
              </Tabs>
              {value == 'overview' && <Box my={2}>
                <Typography variant="body2">
                  <div style={{ textAlign: 'justify' }}>
                    {/* <Typography variant="h5">Outbound List Manager for SFTP</Typography> */}
                    <p><Typography variant="body2">The Outbound List Manager is a robust tool designed to streamline the automation of contact list and DNC list management for companies. This tool facilitates the import of both contact lists and DNC lists from data files located on a configured SFTP server, which can be scheduled to run at regular intervals or triggered on-demand as needed.</Typography></p>
                    <p><Typography variant="body2">Additionally, the Outbound List Manager supports the automated export of contact lists and DNC lists from the GC system to CSV files. These files are then uploaded to a configured SFTP server, ensuring seamless data transfer and integration.</Typography></p>
                    <Typography variant="h6">Key Features:</Typography>
                    <ul>
                      <li><strong>Automated Import and Export:</strong>
                        <ul>
                          <li><strong>Import:</strong> Automate the import of contact lists and DNC lists from data files on a configured SFTP server. This can be scheduled or executed on-demand.</li>
                          <li><strong>Export:</strong> Automate the export of contact lists and DNC lists from the GC system to CSV files, which are then uploaded to a configured SFTP server.</li>
                        </ul>
                      </li>
                      <li><strong>File Encryption:</strong>
                        <ul>
                          <li><strong>Support for Encrypted and Non-Encrypted Files:</strong> Customers can choose to import and export both encrypted and non-encrypted files.</li>
                          <li><strong>PGP Encryption:</strong> If encryption is preferred, customers must provide one or more public keys for PGP encryption to ensure data security during transfer.</li>
                        </ul>
                      </li>
                      <li><strong>Transfer Options:</strong>
                        <ul>
                          <li><strong>Post-Transfer Actions:</strong> Customers can configure the system to either delete or move the imported files after the successful import of contacts and DNC lists, providing flexibility in file management.</li>
                        </ul>
                      </li>
                    </ul>
                    <p><Typography variant="body2">This comprehensive functionality ensures that companies can efficiently manage their contact lists and DNC lists with minimal manual intervention, enhancing productivity and data security.</Typography></p>
                  </div>


                  {/* <p>The Outbound List Manager for SFTP enables companies to automate import of contact lists from data files from a configured SFTP server on either a scheduled or on-demand basis.  </p>
              <p>It also allows the customer to automate exports of contact lists from GC to csv files that are uploaded to a configured sftp server.</p>
              <p>Customers can import, and export encrypted and non-encrypted files. If encryption option is preferred, one or more public keys must be provided for PGP encryption. </p>
              <p>Customers can also set transfer options to either delete or move the imported files after successful import of contacts.</p> */}

                </Typography>
              </Box>
              }
              {value == 'job' && <Box my={1}>
                <div>
                  <Typography variant="body2">

                    The application provides the following features:<ul>
                      <li>Scheduling Importing and export jobs</li>
                      <li>Settings</li>
                      <li>Server management</li>
                    </ul>
                  </Typography>
                </div>

                <Accordion>
                  <AccordionSummary
                    aria-controls="panel1-content"
                    id="panel1-header"
                    expandIcon={<ExpandMoreIcon />}
                  >
                    <b>Status Dashboard</b>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography variant="body2">
                      <div style={{ textAlign: 'justify' }}>
                        <p>The initial view in the app is the Jobs View which is a list of jobs previously created.  This can also be viewed by clicking on the Jobs View icon on the left-hand side, side bar. The list will provide information on the name of the job, description, user who created the job, job schedule as well as job execution details. </p>
                        <p>Jobs can be either scheduled or non-schedule. A scheduled job is one that runs on a predefined ‘one time’ or ‘recurring schedule’. The schedule for a job is defined by a cron string. A non-scheduled job is one that does not have a defined schedule or cron string.</p>
                        <img src="../assets/help/jobmain.png" />
                        <br />
                        <p>
                          In addition to viewing details the user is also provided the following actions:
                          <Typography variant="body2" my={2}>
                            <p> <b> <DeleteIcon fontSize="small" sx={{ verticalAlign: 'middle', mr: 1 }} /> Delete Job </b> </p>
                            <p> To delete a job, click on the delete icon <DeleteIcon fontSize="small" color="error" sx={{ verticalAlign: 'middle' }} /> at the end of each row. A confirmation dialog will be shown to confirm the deletion of the job.
                              Once confirmed, the job will be deleted from the list. The Deleted jobs are available under Archived jobs view, which can be accessed by clicking on the Archived Jobs icon on the left-hand side, side bar. </p>

                            <p> <b> <DeleteIcon fontSize="small" sx={{ verticalAlign: 'middle', mr: 1 }} /> Multiple Job Delete </b> </p>
                            <p> To delete multiple jobs, select the check box on the top of the data table, which will select all jobs. Then click on the DELETE icon <DeleteIcon fontSize="small" color="error" sx={{ verticalAlign: 'middle' }} /> on the right-hand side top corner to delete all selected jobs.</p>

                            <p> <b> <EditIcon fontSize="small" sx={{ verticalAlign: 'middle', mr: 1 }} /> Edit Job </b> </p>
                            <p> To edit a job, click on the pencil/edit icon <EditIcon fontSize="small" color="primary" sx={{ verticalAlign: 'middle' }} />. This will open the job in edit mode, allowing you to make changes. After making changes, click on the SUBMIT button to save the changes.</p>

                            <p> <b> <PlayArrowIcon fontSize="small" sx={{ verticalAlign: 'middle', mr: 1 }} /> / <BlockIcon fontSize="small" sx={{ verticalAlign: 'middle', mr: 1 }} /> Enable/Disable Job </b> </p>
                            <p> Use the enable <PlayArrowIcon fontSize="small" color="success" sx={{ verticalAlign: 'middle' }} /> or disable <BlockIcon fontSize="small" color="error" sx={{ verticalAlign: 'middle' }} /> icons to control scheduled jobs.
                              This is useful when you want to temporarily stop a job from running without deleting it.
                              Once disabled, the job will not run on the configured schedule until it is enabled again.</p>

                            <p> <b> <PlayArrowIcon fontSize="small" sx={{ verticalAlign: 'middle', mr: 1 }} /> Run Job </b> </p>
                            <p> When you click on the run job icon <PlayArrowIcon fontSize="small" color="success" sx={{ verticalAlign: 'middle' }} />, the job will be executed immediately, regardless of its schedule. This is useful for testing or when you need to run a job on demand.</p>

                            <p> <b> <FeedIcon fontSize="small" sx={{ verticalAlign: 'middle', mr: 1 }} /> Job Logs </b> </p>
                            <p> Clicking on the job logs icon <FeedIcon fontSize="small" color="primary" sx={{ verticalAlign: 'middle' }} /> will direct you to a job log screen. This screen displays the details of the job's last 15 runs, including any errors that may have occurred during execution. This feature helps you troubleshoot any issues that may arise.</p>

                            <p> <b> <HistoryIcon fontSize="small" sx={{ verticalAlign: 'middle', mr: 1 }} /> Job Audit Trail </b></p>
                            <p> Clicking on the job audit trail icon <HistoryIcon fontSize="small" color="primary" sx={{ verticalAlign: 'middle' }} /> will direct you to a job audit trail popup dialog. This screen displays the list of modification activity performed on the job</p>
                          </Typography>

                          <p> <b> <ContentCopyIcon fontSize="small" sx={{ verticalAlign: 'middle', mr: 1 }} /> Clone Job </b></p>
                          <p> Clicking on the clone job icon <ContentCopyIcon fontSize="small" color="primary" sx={{ verticalAlign: 'middle' }} /> will create a copy of the job with the same configuration. This is useful when you want to create a similar job without having to configure it from scratch.
                            It also copies the job schedule, transfer options, contact list / DNC list configuration. The cloned job will have a "Copy of" prefix in the job name.
                          </p>

                        </p>
                      </div>
                    </Typography>

                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary
                    aria-controls="panel2-content"
                    id="panel2-header"
                    expandIcon={<ExpandMoreIcon />}
                  >
                    <b> Creating New Job </b>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Tabs
                      value={subTabValue}
                      onChange={subMenuSelect}
                      aria-label="secondary tabs example"
                    >
                      <Tab value="overview" label="Overview" />
                      <Tab value="schedule" label="Schedule" id="schedule-tab" />

                      <Tab value="fileTransfer" label="File Transfer" />
                      <Tab value="contactList" label="Contact List" />
                      <Tab value="dncList" label="DNC List" />
                      <Tab value="customNotification" label="Custom Notification" />
                    </Tabs>

                    {
                      subTabValue == 'overview' && <Box my={2}>
                        <div>
                          <Typography variant="body2">
                            <p> Within this view the user has the option to either edit a pre-defined job or create a new job by clicking on the NEW button.
                            </p>
                            <p>Enter all mandatory fields to configure a job based on your requirements. Click on the SAVE JOB button to save the job to the job list. The new job screen provides the following options:</p>
                          </Typography>
                        </div>
                      </Box>
                    }
                    {
                      subTabValue == 'schedule' && <Box my={2}>
                        <div>
                          <Typography variant="body2">

                            <p>The Schedule section allows the user to create either a schedule or a non-schedule job by toggling the scheduled button. If enabled, the user will be allowed to create a schedule by first selecting the time zone and then selecting a date and time on which the job should run. </p>

                            <p> <b> Creating One Time Schedule</b> </p>
                            <p>The schedule below would run the job one time on the 5th of April at 2:00 PM Los Angeles time (Pacific Time)</p>
                            <img src="../assets/help/onetimeschedule.png" />
                            <hr />
                            <p style={{ paddingTop: "10px" }}> <b> Recursive Schedule - Weekly Once </b></p>
                            <p>The user can also create a recursive schedule by clicking on the Recurrence button and then defining a recurrence with the parameters: minutes, daily, weeks, or months. For e.g., for a schedule of every Monday would set the recurrence as shown below:</p>
                            <img src="../assets/help/recursiveschedule.png" width={"500px"} />
                            <p style={{ paddingTop: "10px" }}> <b> Recursive Schedule - Particular Date in Month</b></p>
                            <p> To run the job only the particular date of the month. Select Repeat Month and select from the list of Days</p>
                            <img src="../assets/help/recursiveschedulemonth.png" width={"500px"} />
                            <p></p>
                            <p><b>Automatic Schedule Generation</b></p>
                            <p>When you select date, time, and recurrence options, the system automatically creates the appropriate schedule for your job. For advanced users, there's also a manual option - select "Cron Expression" to enter your own scheduling pattern. All expressions are validated before saving to ensure your job runs as expected.</p>
                            <p><strong>Note:</strong> The system uses AWS EventBridge Scheduler format for cron expressions. For more information on this format, visit the <a href="https://docs.aws.amazon.com/eventbridge/latest/userguide/eb-create-rule-schedule.html" target="_blank" rel="noopener noreferrer">AWS EventBridge documentation</a>.</p>

                          </Typography>

                        </div>
                      </Box>
                    }


                    {
                      subTabValue == 'fileTransfer' && <Box my={2}>
                        <div>
                          <Typography variant="body2">
                            <p>The transfer options view allows you to select a sftp server and enter the credentials for the job to use when accessing files on that server. The options for connection are:  </p>
                            <ul>
                              <li><b>Username and Password-</b> Authenticate the server using the user name and password to establish the connection </li>
                              <li><b>Ssh key - </b>SSH key is a key pair generated by the Outbound List Manager application. You can click on the Download button key and then upload it to your SFTP server for use.</li>
                              <li><b>Ssh Key and Password-</b> Same as the above except a password can also be used, in addition to the ssh key, </li>
                            </ul>
                            <img src="../assets/help/transferOption.png" width={"500px"} />
                            <p>The app allows the user to test the SFTP connection with all 3 options, by clicking the TEST CONNECTION button. The user needs to specify the folder in which the import files will reside in the Directory field.</p>

                            <p>In addition to connection options, the user can select what needs to be done with the files, after contacts are successfully imported from the files to Genesys Cloud. Users can choose to delete the files or to move them to a specified folder on the SFTP server.</p>
                            <img src="../assets/help/posttransferOption.png" width={"500px"} />

                          </Typography>
                        </div>
                      </Box>
                    }

                    {
                      subTabValue == 'contactList' && <Box my={2}>
                        <div>
                          <Typography variant="h6"> Import Contact List Configuration </Typography>
                          <Typography variant="body2" my={2}>
                            <p>A job can be of one of two types import or export. To import files from a SFTP server, select Import File, then specify a way of identifying data files in the Directory folder, by selecting one of the 6 file format operation options and then entering a file name format.  </p>
                          </Typography>
                          <img src="../assets/help/importContactList.png" width={"500px"} />
                          <p>For example, if the user selects “Starts With” in the File Format Operation and enters “March” as the file format name, then all files beginning with the word “March” will be selected for import from the folder specified under Directory (see transfer options above)</p>
                          <img src="../assets/help/importMatchCondition.png" />
                          <p>If the import files have a .gz or .zip extension, then the files will first be unzipped before they are imported. If the files are encrypted, then they will be decrypted before they are imported (if encryption setting is on)</p>
                          <p>To specify the fields in your contact list you have 2 options.</p>

                          <p><b>1.Upload sample file and map:</b></p>
                          <p>With this option you can use the interface shown below to select a sample csv or xlsx file. The file should be formatted in a way so that it has headers and at least one row of data. Once the data is loaded, you will be able to select the column that will be your contact phone column (mandatory), the type of the column (mandatory) and the column that needs to be used for time zone mapping (optional)</p>
                          <img src="../assets/help/uploadSampleMap.png" width={"500px"} />
                          <p>To find out more about contact list creation in Genesys Cloud click here: <a href="https://help.mypurecloud.com/articles/create-new-contact-list/">https://help.mypurecloud.com/articles/create-new-contact-list/</a></p>

                          <p><b>2)	Use a file import template:</b></p>
                          <p>You can use a file import template for list creation, by selecting from a list of pre-existing import templates. The drop down will show you templates that were created in all division that the user has access to.</p>
                          <img src="../assets/help/importTemplate.png" width={"500px"} />
                          <p>To learn more about import templates, click on the link below: <a href="https://help.mypurecloud.com/articles/create-an-import-template/"> https://help.mypurecloud.com/articles/create-an-import-template/ </a></p>
                          <p><b>3)	Use a file specification template:</b></p>
                          <p>File specification templates allow you to use data files that are delimited by other characters such as pipes, ampersands etc. On more information on these templates please
                            click <a href="https://help.mypurecloud.com/articles/create-a-file-specification-template">https://help.mypurecloud.com/articles/create-a-file-specification-template</a>
                          </p>
                          <p>If you wish to you use files other that comma separated csv or xls files, then you can create “file specification template” in GC. Then within your job configuration, you can select a preexisting “file specification template”.</p>
                          <img src="../assets/help/fileSpec.png" />
                          <p>In addition to the above options, you can also choose to create new contact lists (one for each import file) or append contents of all import files to an existing list. To create new lists, select “New Lists only” from the Append Type drop down. Make sure to select a division in which the new contact list needs to be created.</p>
                          <p>To append lists to an existing contact list, select “Append Only” and select the contact list you would like to append to, from the contact list drop down. This list will only show you contact lists from division that the user has access to.</p>
                          <p>To clear and append to an existing list, select the “Flush and Append” append type.</p>
                          <img src="../assets/help/flushAndAppend.png" width={"500px"} />

                          <p><b>Import Template Splitting Criteria (New in v2.3):</b></p>
                          <p>When using Import Templates with Append Only or Flush and Append operations, you can now use splitting criteria to distribute imported contacts across multiple contact lists:</p>
                          <ul>
                            <li><b>Splitting Criteria Support:</b> Select multiple contact lists to automatically distribute imported data</li>
                            <li><b>Column Structure Validation:</b> All selected contact lists must have identical column structures</li>
                            <li><b>Original Contact List Name Requirement:</b> It is mandatory to enter the name of the list name prefix used to create the initial lists.</li>
                            <li><b>Automatic Validation:</b> The system will warn you if incompatible templates or contact lists are selected</li>
                          </ul>

                          <p>When using splitting criteria with multiple contact lists, you must enter the original contact list name prefix that was used to create the initial contact lists.
                            You can either manually add each distributed lists that needs to be updated or click on the 'Populate' button to automatically add the first 10 (sorted by name) lists. The current limitation for this feature is 10 contact lists per job.</p>
                          <p> Here is an example of a template created in GC with multiple filters.</p>
                          <img src="../assets/help/importtemplate.jpg" width={"500px"} />
                          <p> Below is how you would use the template to create a job in the OLM app.</p>
                          <img src="../assets/help/importtemplateappend.jpg" width={"500px"} />
                          <Typography variant="h6"> Export Contact List Configuration </Typography>
                          <Typography variant="body2" my={2}>
                            <p>The user can create a job that exports contact lists from Genesys Clouds into csv files. The user can select one list per job using the contact lists dropdown. The exported files are then transferred to a folder on the SFTP server. The SFTP server config details, as well as the folder to which the files need to be exported to, can be entered in the File Transfer Options section (see section above)</p>
                            <img src="../assets/help/contactListOption.png" width={"500px"} />
                            <p>Checking the Zip Files option box, results in the exported files being compressed into zip files.</p>
                            <p>Checking the Encrypt Files option results in the exported files being encrypted with all the public keys that are uploaded by users within the Encryption Settings view. If this box is unchecked the job will not encrypt the exported file.</p>
                            <p>If both options are checked the exported file will be first compressed and then encrypted.</p>
                            <img src="../assets/help/compressAndEncrypt.png" width={"500px"} />
                            <p><b>Custom File Names (New in v2.4):</b></p>
                            <p>You can now specify custom file names for your exported contact list files. This feature allows you to:</p>
                            <ul>
                              <li><b>Set Custom Prefix:</b> Define a custom prefix for your exported files instead of using the default contact list name</li>
                              <li><b>Use Date/Time Formatting:</b> Date and time information is included by default in your file names using the configured date and time formats (can be disabled if not needed)</li>
                            </ul>
                            <img src="../assets/help/customFileNamesContactList.png" width={"500px"} />
                          </Typography>
                        </div>
                      </Box>
                    }


                    {
                      subTabValue == 'dncList' && <Box my={2}>
                        <div>
                          <Typography variant="h6"> Import DNC List Configuration </Typography>
                          <Typography variant="body2" my={2}>
                            <p>The user can configure a job that imports files from the sftp server and creates DNC lists in Genesys Cloud. Only csv files are supported by GC, at this moment. The upload of csv file, selection of columns as well as SFTP server setup, is similar to the one described in Import Contact List Configuration.</p>

                            <p><b>DNC List Type Selection (New in v3.1):</b></p>
                            <p>You can now select the DNC List type when creating import jobs. In previous versions, this selection was not available and all DNC lists were created as "Internal-Custom" by default. The following types are now available:</p>
                            <ul>
                              <li><b>Internal-Custom:</b> DNC list with support for custom exclusion columns. Use this when you need advanced filtering based on custom criteria.</li>
                              <li><b>Internal:</b> Standard internal DNC list for phone number exclusions.</li>
                            </ul>
                            <p>Both types support expiration date columns for time-based DNC entries.</p>
                            <img src="../assets/help/dncListTypes.png" width={"500px"} />

                            <p>When using "Internal-Custom" type, you can additionally specify "Custom Exclusion Column". Both types support "DNC upload Columns" and "DNC Expiration Column". For more details on DNC Lists, please refer to:
                              <a href="https://help.mypurecloud.com/articles/create-new-dnc-list/"> https://help.mypurecloud.com/articles/create-new-dnc-list/</a>
                            </p>
                            <img src="../assets/help/importMatchCondition.png" />
                          </Typography>


                          <Typography variant="h6"> Export DNC List Configuration </Typography>
                          <Typography variant="body2" my={2}>
                            <p>This job configuration allows for exporting of DNC lists into files that are transferred to the SFTP server. The configuration is like the one described in Export Contact List Configuration. </p>

                            <img src="../assets/help/exportDNC.png" />
                            <p><b>Custom File Names (New in v2.4):</b></p>
                            <p>Similar to contact list exports, you can now specify custom file names for your exported DNC list files. This feature provides:</p>
                            <ul>
                              <li><b>Custom Naming:</b> Define custom prefixes for your DNC list export files</li>
                              <li><b>Date/Time Integration:</b> Date and time information is included by default in file names using the configured formats (can be disabled if not needed)</li>
                            </ul>
                            <img src="../assets/help/customFileNamesDNC.png" width={"500px"} />
                          </Typography>
                        </div>
                      </Box>
                    }

                    {
                      subTabValue == 'customNotification' && <Box my={2}>
                        <div>
                          <Typography variant="h6"> Custom Notification </Typography>
                          <Typography variant="body2" my={2}>
                            <p> The Outbound List Manager allows you to configure custom email notifications for job failures at individual job level.
                              You can add multiple email addresses to receive notifications. The email addresses can be added in the Custom Notification section of the job configuration.
                              It overrides the organization level notification settings. </p>
                            <img src="../assets/help/customNotification.png" width={500} />
                          </Typography>

                        </div>
                      </Box>
                    }



                  </AccordionDetails>
                </Accordion>
              </Box>}

              {value == 'cloudStorage' && <Box my={2}>
                <Typography variant="h5" my={2}> Cloud Storage Management </Typography>
                <Typography variant="body2">
                  <p>The <strong>Cloud Storage Management</strong> feature allows you to configure and manage AWS S3 storage as an alternative to traditional SFTP servers. This provides enhanced scalability, security, and cost-effectiveness for your file operations.</p>

                  <div>
                    <Typography variant="h6"> AWS S3 Configuration </Typography>
                    <p>To configure AWS S3 storage, you'll need to provide the following information:</p>
                    <ul>
                      <li><strong>AWS Access Key ID</strong>: Your AWS access key for authentication</li>
                      <li><strong>AWS Secret Access Key</strong>: Your AWS secret key for secure access</li>
                      <li><strong>S3 Bucket Name</strong>: The name of your S3 bucket where files will be stored</li>
                      <li><strong>AWS Region</strong>: The AWS region where your S3 bucket is located</li>
                      <li><strong>Folder Path</strong>: Optional folder path within the bucket for organizing files</li>
                    </ul>
                  </div>

                  <div>
                    <Typography variant="h6"> Security Best Practices </Typography>
                    <p>When configuring S3 storage, follow these security recommendations:</p>
                    <ul>
                      <li><strong>Use IAM Roles</strong>: Create dedicated IAM roles with minimal required permissions</li>
                      <li><strong>Enable Encryption</strong>: Use S3 server-side encryption for data at rest</li>
                      <li><strong>Access Logging</strong>: Enable S3 access logging for audit trails</li>
                      <li><strong>Bucket Policies</strong>: Implement restrictive bucket policies to limit access</li>
                    </ul>
                  </div>

                  <div>
                    <Typography variant="h6"> Testing Connection </Typography>
                    <p>Before using S3 storage in your jobs, test the connection to ensure proper configuration:</p>
                    <ol>
                      <li>Enter your S3 configuration details</li>
                      <li>Click the <strong>"Test Connection"</strong> button</li>
                      <li>Verify that the connection is successful</li>
                      <li>Save the configuration for use in jobs</li>
                    </ol>
                  </div>
                </Typography>
              </Box>}

              {value == 'apiRetrieval' && <Box my={2}>
                <Typography variant="h5" my={2}> API-Based Data Retrieval </Typography>
                <Typography variant="body2">
                  <p>The <strong>API-Based Data Retrieval</strong> feature enables direct integration with external systems and APIs, eliminating the need for intermediate file transfers. This allows for real-time data synchronization from CRM systems, databases, and other business applications.</p>

                  <div>
                    <Typography variant="h6"> Supported Datasource Types </Typography>
                    <p>The system supports various datasource types with optimized configurations:</p>
                    <ul>
                      <li><strong>ServiceNow CRM</strong>: OAuth 2.0 authentication with GET method support</li>
                      <li><strong>Microsoft Dynamics 365</strong>: OAuth 2.0 authentication for secure access</li>
                      <li><strong>SOAP Web Service</strong>: Basic authentication with SOAP Action and XML envelope support</li>
                      <li><strong>Genesys Cloud</strong>: Native integration using current session</li>
                      <li><strong>Custom APIs</strong>: Flexible configuration for any REST API</li>
                    </ul>
                  </div>

                  <div>
                    <Typography variant="h6"> Authentication Methods </Typography>
                    <p>Multiple authentication methods are supported based on your API requirements:</p>
                    <ul>
                      <li><strong>OAuth 2.0</strong>: Secure, token-based authentication (recommended for CRM systems)</li>
                      <li><strong>API Key</strong>: Simple key-based authentication with customizable headers</li>
                      <li><strong>Bearer Token</strong>: Token-based authentication for modern APIs</li>
                      <li><strong>Basic Authentication</strong>: Username/password authentication for legacy systems</li>
                      <li><strong>Custom Headers</strong>: Support for specialized authentication requirements</li>
                    </ul>
                  </div>

                  <div>
                    <Typography variant="h6"> Datasource Configuration </Typography>
                    <p>To configure a new datasource for API retrieval:</p>
                    <ol>
                      <li>Navigate to the <strong>Datasource Management</strong> section</li>
                      <li>Click <strong>"Add New Datasource"</strong></li>
                      <li>Select the appropriate datasource type</li>
                      <li>Configure authentication details based on the selected method</li>
                      <li>Test the connection to verify configuration</li>
                      <li>Save the datasource for use in jobs</li>
                    </ol>
                  </div>

                  <div>
                    <Typography variant="h6"> API Retrieval Job Configuration </Typography>
                    <p>When creating jobs with API retrieval:</p>
                    <ul>
                      <li><strong>API URL</strong>: Specify the endpoint URL for data retrieval</li>
                      <li><strong>Datasource Selection</strong>: Choose from configured datasources</li>
                      <li><strong>HTTP Method</strong>: Automatically configured based on datasource type</li>
                      <li><strong>Request Body</strong>: Optional request payload for POST/PUT methods</li>
                      <li><strong>Data Format</strong>: JSON or XML response format handling</li>
                      <li><strong>Record Path</strong>: JSONPath or XPath for extracting contact records</li>
                    </ul>
                  </div>

                  <div>
                    <Typography variant="h6"> Testing API Connections </Typography>
                    <p>Always test your API configuration before creating jobs:</p>
                    <ol>
                      <li>Configure your API URL and select a datasource</li>
                      <li>Click <strong>"Test Connection"</strong> to verify the API response</li>
                      <li>Review the returned data structure</li>
                      <li>Adjust record path and data mapping as needed</li>
                      <li>Ensure the API returns the expected contact data format</li>
                    </ol>
                  </div>
                </Typography>
              </Box>}


              {value == 'settings' && <Box my={2}>

                {/* STORAGE TYPE SETTINGS */}
                <Typography variant="h6"> Storage Type Settings </Typography>
                <Typography variant="body2">
                  <p> Configure the default storage type for your organization. Choose between SFTP, AWS S3, or API-based retrieval methods.</p>
                  <ul>
                    <li><strong>SFTP:</strong> Traditional file transfer protocol for secure file operations</li>
                    <li><strong>AWS S3:</strong> Cloud-based storage with enhanced scalability and security</li>
                    <li><strong>API:</strong> Direct integration with external systems for real-time data retrieval</li>
                  </ul>
                  <p>This setting determines which storage options are available when creating new jobs and affects the visibility of related menu items in the application.</p>
                </Typography>

                {/* NOTIFICATION SETTINGS */}
                <Typography variant="h6"> Notification Settings </Typography>
                <Typography variant="body2">
                  <p> User can add emails addresses on which they wish to receive job failure notifications.</p>
                </Typography>
                <img src="../assets/help/addEmail.png" width={"500px"} />


                {/*ENCRYPTION SETTINGS */}
                <Typography variant="h6"> Encryption Settings </Typography>
                <Typography variant="body2">
                  <p> This view has the following components-</p>
                  <ul>
                    <p><b>Secure all Contact Lists -</b>  Enables encryption for all Contact Lists. When enabled, you cannot enable/disable encryption for one specific Contact list. An export job will encrypt exported files using all public keys files uploaded by the user. </p>
                    <p><b>Public Keys - </b> A list of User Public Keys that include:</p>
                    <p><b>Type - </b> The type of key.</p>
                    <p><b>User ID - </b> the user ID associated with the specific Public Key.</p>
                    <p><b>Upload Date - </b> The date and time at which the Public Key was uploaded into CX Contact.</p>
                    <p><b>Algorithm -</b>  Displays the public key algorithm provided by the List Builder</p>
                    <p><b>Expiration Date -</b>  Displays the key expiration date for the public key or Never if the key never expires.</p>
                    <p><b>Import -</b>  Enables you to import a user's public keys. When this option is selected an Import Public Key dialog is opened. In the Enter Public Key UserID field, enter the unique User ID, select the file that contains the Public Key that the app should use for data encryption and click Import. The app supports rsa3072 and rsa4096 Public Keys in plain text (ASCII Armor) format.</p>
                    <p><b>Download CX Contact Public Key -</b>  Enables you to download a “Outbound list Manager for SFTP” Public key that should be used to encrypt data files before uploading them to the app. </p>
                  </ul>
                  <img src="../assets/help/encryption.png" width={"500px"} />
                </Typography>


              </Box>
              }


              {value == 'serverManagement' && <Box my={2}>
                <Typography variant="h5" my={2}> Managing Servers </Typography>
                <Typography variant="body2">
                  <p>The <strong>Server Management Page</strong> provides a comprehensive interface for managing your SFTP servers. You can <strong>add new servers</strong>, <strong>edit existing servers</strong>, and <strong>remove servers</strong>, all with built-in connection testing and impact analysis.</p>

                  <div>
                    <Typography variant="h6"> Adding a New Server </Typography>
                    <img src="../assets/help/AddServer.png" width={"600px"} />
                    <p>To add a new server, click the <strong>"Add"</strong> button at the top of the page. A dialog will appear with the following fields:</p>
                    <ul>
                      <li><strong>Server Name *</strong>: The domain name or IP address of the SFTP server.</li>
                      <li><strong>User Name *</strong>: The username used to authenticate with the server.</li>
                      <li><strong>Authentication Method</strong>: Select one of three options:
                        <ul>
                          <li><strong>Password</strong>: Authenticate using a username and password.</li>
                          <li><strong>SSH Key</strong>: Authenticate using an SSH key pair generated by the application. Click <strong>"Download SSH"</strong> to download the public key and upload it to your SFTP server.</li>
                          <li><strong>SSH Key &amp; Password</strong>: Authenticate using both an SSH key and a password for added security.</li>
                        </ul>
                      </li>
                      <li><strong>Password *</strong>: Required when using Password or SSH Key &amp; Password authentication. Disabled when SSH Key only is selected.</li>
                      <li><strong>Port *</strong>: The port number on which the SFTP server listens (commonly 22).</li>
                    </ul>
                    <p>Once all required fields are filled in, click <strong>"Save"</strong> to add the server to the list.</p>
                  </div>

                  <div>
                    <Typography variant="h6"> Testing the Connection </Typography>
                    <p>Before saving, you can verify your credentials by clicking the <strong>"Test Connection"</strong> button inside the dialog. The application will attempt to connect to the SFTP server using the provided details and display the result — either a success message or an error indicating invalid credentials or a connection failure.</p>
                  </div>

                  <div>
                    <Typography variant="h6"> Editing an Existing Server </Typography>
                <img src="../assets/help/EditServer.png" width={"600px"} />

                    <p>To edit a server, click the <strong>edit icon <EditIcon fontSize="small" sx={{ verticalAlign: 'middle' }} /></strong> in the Actions column of the server list. The edit dialog will open with all existing server details pre-filled. Note that the <strong>Server Name is locked</strong> and cannot be changed during edit.</p>
                    <p>If any jobs are currently using this server, an informational alert will appear showing the number of impacted jobs. Click <strong>"Know more"</strong> to view the list of automation names that depend on this server before making changes.</p>
                    <p>After updating the fields, click <strong>"Update"</strong> to save the changes. If the username or password is changed, the system will automatically refresh the stored credentials on the backend.</p>
                  </div>

                  <div>
                    <Typography variant="h6"> Removing an Existing Server </Typography>
                <img src="../assets/help/DeleteServer.png" width={"600px"} />

                    <p>To delete a server, click the <strong>delete icon <DeleteIcon fontSize="small" sx={{ verticalAlign: 'middle' }} /></strong> in the Actions column. A confirmation dialog will appear showing:</p>
                    <ul>
                      <li>The name of the server to be deleted.</li>
                      <li>Whether any jobs are currently using this server. If jobs are impacted, a warning will be shown with the count. Click <strong>"Know more"</strong> to view which jobs will be affected.</li>
                      <li>If no jobs use the server, an informational message confirms it is safe to delete.</li>
                    </ul>
                    <p>Click <strong>"Delete"</strong> to confirm and permanently remove the server from the list.</p>
                  </div>

                  <div>
                    <Typography variant="h6"> Legacy Servers ("Not Configured") </Typography>
                    <p>Servers that were added in older versions of the application may only have a server name stored, without credentials. These entries are marked with a <strong>"Not configured"</strong> badge in the server list. Current jobs will continue to work without an issue, even if this configuration is not changed. .</p>
                  </div>
                </Typography>
                <img src="../assets/help/legacyServer.png" width={"600px"} />

              </Box>

              }

              {value == 'install' && <Box my={2}>
                <Typography variant="h5" my={2}> Installation  </Typography>
                <Typography variant="body2">
                  <p style={{ textAlign: 'justify' }}>
                    When the application is launched first time in the Genesys Cloud Organization using AppFoundry. It will check for installation status automatically.
                    If the application is not installed, it will redirect to the installation page. The installation page will guide you through the steps required to install the application.
                  </p>

                  <Typography variant="h6">  Edition Available </Typography>
                  <Box my={2}>
                    <p> The Outbound List Manager is available in the following editions:
                      <ul>
                        <li> <b> Standard Edition </b> - This edition is available for customers in the US region. </li>
                      </ul>
                    </p>
                  </Box>

                  <Typography variant="h6">  Installation Steps </Typography>
                  <p> The installation process consists of 3 steps. The user can navigate through the steps using the Next and Previous buttons. </p>
                  <Divider />
                  <Typography variant="body1">
                    <b> Step 1 - Welcome Screen & SFTP Edition Selection </b>
                  </Typography>

                  <p> This page will be seen if this application is opened for the first time in an organization.
                    Click the Start button to begin </p>
                  <img src="../assets/help/installScreen1.png" width={"600px"} />
                  {/* <Typography variant="body1">   Step 2 - Installation Screen </Typography> */}
                  <Typography variant="body1"> <b> Step 2 - Installation Screen </b> </Typography>
                  <p>
                    This page shows the list of resources which will be created as part of the installation. Click the Submit button to create the OAuth integration and application roles
                  </p>
                  <img src="../assets/help/installScreen2.png" width={"600px"} />

                  <Typography variant="body1"> <b> Step 3 - Success Screen </b> </Typography>
                  <p>
                    Once the installation is completed the following page with a success message is shown.
                    By clicking on Finish you can start using the application.No custom user permissions are needed for running this app; however, it is assumed that the user of this app has admin access for the division(s) for which they want to import/export contact lists.
                  </p>
                  <img src="../assets/help/installScreen3.png" width={"600px"} />

                </Typography>

              </Box>

              }

            </Box>
          )}
          {mainTab === "releaseNotes" && (
            <Box my={2}>
              <Typography variant="h5">Release Notes</Typography>

              {/* Version 3.3 */}
              <Box sx={{ mb: 3, mt: 2, p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                <Typography variant="h6" sx={{ mb: 1 }}>
                  Version 3.3 <Chip size="small" label="Latest" color="primary" sx={{ ml: 1 }} />
                </Typography>
                <Typography variant="caption" display="block" sx={{ mb: 2 }}>
                  Released: May 24, 2026
                </Typography>
                <p>
                  Genesys Cloud is phasing out the legacy contact-list upload API in favor of Darth (API-based presigned uploads). The legacy upload API is set to be decommissioned by the end of June—please enable Darth under{" "}
                  <strong>Settings → Internal Upload settings</strong> and test your import jobs before cutover.{" "}
                  <Link href="https://developer.genesys.cloud/announcements/e0b2b552-505f-440d-b769-4eb2260255dc" target="_blank" rel="noopener noreferrer">
                    Genesys Cloud platform announcement
                  </Link>
                  .
                </p>

                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mt: 1 }}>
                    Genesys upload migration (Darth)
                  </Typography>
                  <ul>
                    <li>
                      New organization-wide control under <strong>Settings → Internal Upload settings</strong>: <strong>Enable Darth API</strong> routes contact list uploads through the Darth presigned URL API instead of the legacy upload API.
                    </li>
                    <li>
                      The legacy upload API remains the <strong>default</strong> until an administrator enables Darth; use this window to compare behavior and fix issues before the legacy API is retired.
                    </li>
                  </ul>
                </Box>
              </Box>

              {/* Version 3.2 */}
              <Box sx={{ mb: 3, mt: 2, p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                <Typography variant="h6" sx={{ mb: 1 }}>
                  Version 3.2
                </Typography>
                <Typography variant="caption" display="block" sx={{ mb: 2 }}>
                  Released: March 24, 2026
                </Typography>

                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                  What&apos;s New
                </Typography>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mt: 1 }}>
                    API Datasources
                  </Typography>
                  <ul>
                    <li>Added support for SOAP Web Service for API Datasources.</li>
                  </ul>

                  <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mt: 2 }}>
                    Import Reliability
                  </Typography>
                  <ul>
                    <li>Added import status validation before flush list operations.</li>
                    <li>Added clear status validation before import processing for flush and append type of jobs.</li>
                  </ul>

                  <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mt: 2 }}>
                    CSV Validation
                  </Typography>
                  <ul>
                    <li>Added column matching checks for import jobs.</li>
                  </ul>
                </Box>
              </Box>

              {/* Version 3.1 */}
              <Box sx={{ mb: 3, mt: 2, p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                <Typography variant="h6" sx={{ mb: 1 }}>
                  Version 3.1
                </Typography>
                <Typography variant="caption" display="block" sx={{ mb: 2 }}>
                  Released: March 9, 2026
                </Typography>

                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                  What's New
                </Typography>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mt: 1 }}>
                    Jobs
                  </Typography>
                  <ul>
                    <li>New "In Progress" status — jobs now display an "In Progress" status in the Jobs view when they are running</li>
                    </ul>

                  <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mt: 2 }}>
                    DNC List
                  </Typography>
                  <ul>
                    <li>DNC List Type Selection — choose between "Internal-Custom" and "Internal" DNC list types when importing</li>
                  </ul>

                  <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mt: 2 }}>
                    Server Management
                  </Typography>
                  <ul>
                    <li>Enhanced SFTP Server Management — full credential management, authentication method selection, and connection testing</li>                   
                    <li>Ability to update / edit username and password for existing servers.</li>
                    <li>Legacy server detection with "Not configured" indicator. <br />
                      <span style={{ fontSize: '12px' }}>Note: Current jobs will continue to work without an issue, even if server configuration is not configured.</span></li>
                  </ul>

                  <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mt: 2 }}>
                    Selective Column Export
                  </Typography>
                  <ul>
                    <li>Export Contact List jobs now include a "Select Columns" option to choose exactly which contact list fields are exported.</li>
                    <li>When you open the column picker, all available columns are selected by default, and you can quickly select or deselect individual columns.</li>
                    <li>Selected columns are saved with the job and restored during edit, so exports stay consistent across scheduled and on-demand runs.</li>
                  </ul>
                </Box>

                <Divider sx={{ my: 2 }} />

                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography><Chip size="small" label="New" color="success" sx={{ mr: 1 }} /> DNC List Type Selection</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>
                      You can now select the DNC List type when importing DNC lists. This provides flexibility for different use cases and compliance requirements.
                      <p></p>
                      <strong>Available DNC List Types:</strong>
                      <ul>
                        <li><strong>Internal-Custom:</strong> DNC list with support for custom exclusion columns. Ideal for advanced filtering based on custom criteria.</li>
                        <li><strong>Internal:</strong> Standard internal DNC list for phone number exclusions.</li>
                      </ul>
                      <p>Both types support expiration date columns for time-based DNC entries.</p>
                      <p><em>Note: In previous versions, DNC list type selection was not available and all DNC lists were created as "Internal-Custom" by default.</em></p>
                      <p></p>
                      <Link
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          setMainTab("userManual");
                          setValue("job");
                          setTimeout(() => {
                            const creatingJobAccordion = document.getElementById("panel2-header");
                            if (creatingJobAccordion) {
                              creatingJobAccordion.click();
                              setTimeout(() => {
                                setSubTabValue("dncList");
                              }, 100);
                            }
                          }, 100);
                        }}
                        underline="hover"
                      >
                        View DNC List configuration guide
                      </Link>
                    </Typography>
                  </AccordionDetails>
                </Accordion>

                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography><Chip size="small" label="Enhanced" color="info" sx={{ mr: 1 }} /> Server Management</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>
                      The Server Management page has been significantly upgraded. Servers now store full connection credentials — username, password, port, and authentication method — enabling secure reuse across multiple jobs.
                      <p></p>
                      <strong>New capabilities:</strong>
                      <ul>
                        <li><strong>Authentication Method Selection:</strong> Choose between Password, SSH Key, or SSH Key &amp; Password when adding or editing a server</li>
                        <li><strong>SSH Key Download:</strong> Download the application-generated SSH public key directly from the server form to upload to your SFTP server</li>
                        <li><strong>Test Connection:</strong> Verify server credentials before saving using the built-in connection test</li>
                        <li><strong>Edit Server:</strong> Update credentials for any existing server via the edit icon in the server list</li>
                        <li><strong>Impacted Jobs Analysis:</strong> When editing or deleting a server, the system automatically checks how many jobs depend on it and displays a warning with a "Know more" option to view the affected job names</li>
                        <li><strong>Legacy Server Detection:</strong> Servers added in older versions without full credentials are flagged with a "Not configured" badge, prompting reconfiguration</li>
                      </ul>
                      <p></p>
                      <Link
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          setMainTab("userManual");
                          setValue("serverManagement");
                        }}
                        underline="hover"
                      >
                        View Server Management guide
                      </Link>
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              </Box>

              {/* Version 3.0 */}
              <Box sx={{ mb: 3, mt: 2, p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                <Typography variant="h6" sx={{ mb: 1 }}>
                  Version 3.0 beta
                </Typography>
                <Typography variant="caption" display="block" sx={{ mb: 2 }}>
                  Beta Release: November 11, 2025
                </Typography>

                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                  What's New
                </Typography>
                <Box sx={{ mb: 2 }}>
                  <ul>
                    <li>AWS S3 storage support for cloud-based file management</li>
                    <li>API-based data retrieval from external systems</li>                    
                  </ul>
                  <Typography>Note: No changes to existing or new SFTP jobs</Typography>
                </Box>

                <Divider sx={{ my: 2 }} />

                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography><Chip size="small" label="New" color="success" sx={{ mr: 1 }} /> AWS S3 Storage Support</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>
                      Expand beyond traditional SFTP with native AWS S3 integration. Store and retrieve your contact lists and DNC lists directly from Amazon S3 buckets with enterprise-grade security and scalability.
                      <p></p>
                      <strong>Key Benefits:</strong>
                      <ul>
                        <li>Seamless integration with AWS S3 for cloud-native file storage</li>
                        <li>Enhanced security with AWS IAM roles and policies</li>
                        <li>Improved scalability and reliability for large file operations</li>
                        <li>Cost-effective storage solution for high-volume data processing</li>
                      </ul>
                      <p></p>
                      <strong>How it works:</strong>
                      <ul>
                        <li>Configure S3 bucket credentials in the Cloud Storage Management section</li>
                        <li>Select S3 as your storage type when creating jobs</li>
                        <li>All existing job features work seamlessly with S3 storage</li>
                      </ul>
                    </Typography>
                  </AccordionDetails>
                </Accordion>

                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography><Chip size="small" label="New" color="success" sx={{ mr: 1 }} /> API-Based Data Retrieval</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>
                      Connect directly to external systems and APIs to retrieve contact data without intermediate file transfers. This powerful feature enables real-time data synchronization from CRM systems, databases, and other business applications.
                      <p></p>
                      <strong>Supported Systems:</strong>
                      <ul>
                        <li>ServiceNow CRM with OAuth 2.0 authentication</li>
                        <li>Microsoft Dynamics 365 with OAuth 2.0 authentication</li>
                        <li>SOAP Web Services with Basic Authentication</li>
                        <li>Custom REST APIs with multiple authentication methods</li>
                        <li>Genesys Cloud APIs for internal data operations</li>
                      </ul>
                      <p></p>
                      <strong>Authentication Methods:</strong>
                      <ul>
                        <li>OAuth 2.0 for secure, token-based authentication</li>
                        <li>API Key authentication for simple integrations</li>
                        <li>Bearer Token authentication for modern APIs</li>
                        <li>Basic Authentication for legacy systems and SOAP services</li>
                        <li>Custom headers for specialized requirements</li>
                      </ul>
                      <p></p>
                      <strong>How to get started:</strong>
                      <ul>
                        <li>Create datasource configurations in the Datasource Management section</li>
                        <li>For SOAP services, provide the WSDL endpoint URL and SOAP envelope</li>
                        <li>Test API connections before creating jobs</li>
                        <li>Configure data mapping and transformation rules</li>
                        <li>Schedule regular API-based imports just like file-based jobs</li>
                      </ul>
                    </Typography>
                  </AccordionDetails>
                </Accordion>


              </Box>

              {/* Version 2.4.1 */}
              <Box sx={{ mb: 3, p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                <Typography variant="h6" sx={{ mb: 1 }}>
                  Version 2.4.1
                </Typography>
                <Typography variant="caption" display="block" sx={{ mb: 2 }}>
                  Released: September 8, 2025
                </Typography>

                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                  What's New
                </Typography>
                <Box sx={{ mb: 2 }}>
                  <ul>
                    <li>Job history log increased to accommodate logs for 48 runs</li>
                    <li>File import limit: Maximum 30 files per job (excess files logged with notification)</li>
                    <li>Concurrent job limit: Maximum 10 jobs running simultaneously (applies to new import jobs only)</li>
                  </ul>
                </Box>

                <Divider sx={{ my: 2 }} />

                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography><Chip size="small" label="Enhanced" color="info" sx={{ mr: 1 }} /> Extended Job History</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>
                      Job history logs have been expanded to store information for up to 48 job runs, providing better visibility into job performance and troubleshooting capabilities over extended periods.
                    </Typography>
                  </AccordionDetails>
                </Accordion>

                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography><Chip size="small" label="New" color="success" sx={{ mr: 1 }} /> File Import Restrictions</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>
                      To ensure optimal performance and system stability, each job is now limited to processing a maximum of 30 files per execution. If your file format setting retrieves more than 30 files, only the first 30 will be processed. The remaining file names will be logged, and you'll receive a notification about the excess files.
                      <p></p>
                      <strong>What this means:</strong>
                      <ul>
                        <li>Jobs will process the first 30 files found that match your criteria</li>
                        <li>Excess files are logged for your reference</li>
                        <li>You'll receive notifications when files are skipped due to this limit</li>
                      </ul>
                    </Typography>
                  </AccordionDetails>
                </Accordion>

                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography><Chip size="small" label="New" color="success" sx={{ mr: 1 }} /> Concurrent Job Limits</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>
                      To maintain system performance and prevent resource conflicts, the number of jobs that can run simultaneously has been limited to 10. This restriction applies only to newly created jobs - existing jobs will continue to operate without this limitation. The following message will appear when cloning or saving a job that has the same schedule as 10 other jobs. 
                      <p></p>
                      <img src="../assets/help/concurrent job message.png" width={"500px"} />
                      <p></p>
                      <strong>Important notes:</strong>
                      <ul>
                        <li>Maximum of 10 jobs can run concurrently</li>
                        <li>This limit applies only to jobs created or updated after this release</li>
                        <li>Existing jobs are not affected by this change</li>
                        <li>This applies only to import jobs</li>
                      </ul>
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              </Box>

              {/* Version 2.4 */}
              <Box sx={{ mb: 3, p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                <Typography variant="h6" sx={{ mb: 1 }}>
                  Version 2.4
                </Typography>
                <Typography variant="caption" display="block" sx={{ mb: 2 }}>
                  Released: September 1 2025
                </Typography>

                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                  What's New
                </Typography>
                <Box sx={{ mb: 2 }}>
                  <ul>
                    <li>Custom file names for contact list and DNC list exports</li>
                  </ul>
                </Box>

                <Divider sx={{ my: 2 }} />

                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography><Chip size="small" label="New" color="success" sx={{ mr: 1 }} /> Custom File Names for Exports</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>
                      Take control of your exported file naming with the new custom file names feature. This enhancement allows you to define consistent, meaningful names for both contact list and DNC list exports.
                      <p></p>
                      <strong>Key Benefits:</strong>
                      <ul>
                        <li>Define custom prefixes for exported files instead of using default list names</li>
                        <li>Integrate optional date and time into file names</li>
                      </ul>
                      <p></p>
                      <strong>How it works:</strong>
                      <ul>
                        <li>Available for both contact list and DNC list export jobs</li>
                        <li>Combines your custom prefix with formatted timestamps for unique file names</li>
                      </ul>
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              </Box>

              {/* Version 2.3 */}
              <Box sx={{ mb: 3, p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                <Typography variant="h6" sx={{ mb: 1 }}>
                  Version 3.0 beta
                </Typography>
                <Typography variant="caption" display="block" sx={{ mb: 2 }}>
                  Released: September 2024
                </Typography>

                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                  What's New
                </Typography>
                <Box sx={{ mb: 2 }}>
                  <ul>
                    <li>Import Template support for Append Only and Flush and Append operations</li>
                    <li>Advanced splitting criteria to distribute contacts across multiple lists</li>
                    <li>Enhanced validation for import template compatibility</li>
                  </ul>
                </Box>

                <Divider sx={{ my: 2 }} />

                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography><Chip size="small" label="New" color="success" sx={{ mr: 1 }} /> Import Template Support</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>
                      You can now use Import Templates for both standard imports and advanced splitting criteria scenarios. For both scenarios, you will need to enter the 'List Name Prefix' used for the original contact lists.
                      <p></p>
                      <strong>Standard Import Template Usage:</strong>
                      <ul>
                        <li>Use Import Templates for Append Only and Flush and Append operations</li>
                        <li>Select a single contact list to append imported data</li>
                      </ul>
                      <p></p>
                      <strong>Splitting Criteria (Advanced):</strong>
                      <ul>
                        <li>Distribute imported contacts across multiple contact lists automatically (max 10 per job)</li>
                        <li>Select multiple contact lists to split the imported data</li>
                        <li>System validates that all selected contact lists have matching column structures</li>
                      </ul>
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              </Box>

              {/* Version 2.2 */}
              <Box sx={{ mb: 3, p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                <Typography variant="h6" sx={{ mb: 1 }}>
                  Version 2.2
                </Typography>
                <Typography variant="caption" display="block" sx={{ mb: 2 }}>
                  Released: June 18, 2025
                </Typography>

                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                  What's New
                </Typography>
                <Box sx={{ mb: 2 }}>
                  <ul>
                    <li>Schedule jobs in your local timezone with automatic DST adjustments</li>
                    <li>Clone existing jobs with a single click</li>
                    <li>Persistent filter settings across view changes</li>
                    <li>Custom email notifications for job failures</li>
                    <li>Track job changes with the new Audit Trail</li>
                    <li>Access deleted jobs in the new Archived View</li>
                    <li>Quickly identify issues with the new Failed Jobs View</li>
                  </ul>
                </Box>

                <Divider sx={{ my: 2 }} />

                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography><Chip size="small" label="New" color="success" sx={{ mr: 1 }} /> Schedule jobs in your local timezone</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>
                      You can now schedule jobs in your local timezone - they'll automatically adjust for daylight saving time changes. This ensures your jobs always run at the expected local time, regardless of DST transitions.
                      <p></p>
                      <strong>What you need to know:</strong>
                      <ul>
                        <li>This applies to newly created jobs only</li>
                        <li>Existing jobs will continue to use UTC time</li>
                        <li>The scheduling interface has been simplified - day and time selection is now handled in the main dialog</li>
                      </ul>
                      <Link
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          // Navigate to the schedule section
                          setMainTab("userManual");
                          setValue("job");
                          setTimeout(() => {
                            const creatingJobAccordion = document.getElementById("panel2-header");
                            if (creatingJobAccordion) {
                              creatingJobAccordion.click();
                              setTimeout(() => {
                                setSubTabValue("schedule");
                              }, 100);
                            }
                          }, 100);
                        }}
                        underline="hover"
                      >
                        Learn more about recurrence scheduling
                      </Link>
                    </Typography>
                  </AccordionDetails>
                </Accordion>

                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography><Chip size="small" label="New" color="success" sx={{ mr: 1 }} /> Clone jobs with a single click</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>
                      Save time by duplicating existing jobs with all their configurations intact. Look for the new Clone button in the top right corner when you select a job.
                      <p></p>
                      <strong>How it works:</strong>
                      <ul>
                        <li>Cloned jobs are automatically named "Copy of [original job name]"</li>
                        <li>All settings from the original job are preserved</li>
                        <li>Timezone settings are maintained as in the original job</li>
                        <li>You can only clone one job at a time</li>
                      </ul>
                    </Typography>
                  </AccordionDetails>
                </Accordion>

                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography><Chip size="small" label="Improved" color="info" sx={{ mr: 1 }} /> Persistent filter settings</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>
                      Your filter preferences now stick around even when you navigate away or refresh the page. For example, if you filter jobs by name, that filter will remain active when you return to the Jobs View.
                    </Typography>
                  </AccordionDetails>
                </Accordion>

                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography><Chip size="small" label="New" color="success" sx={{ mr: 1 }} /> Custom job failure notifications</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>
                      Ensure the right people are notified when specific jobs fail. You can now set up custom email notifications at the individual job level.
                      <p></p>
                      <strong>How to set up:</strong>
                      <ul>
                        <li>Go to the new Notifications tab next to the Schedule tab</li>
                        <li>Enable custom notifications and add the email addresses you want to notify</li>
                        <li>If custom notifications are enabled but no emails are specified, the system will use your organization's default notification settings</li>
                      </ul>
                      <Link
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          // Navigate to the custom notifications section
                          setMainTab("userManual");
                          setValue("job");
                          setTimeout(() => {
                            const creatingJobAccordion = document.getElementById("panel2-header");
                            if (creatingJobAccordion) {
                              creatingJobAccordion.click();
                              setTimeout(() => {
                                setSubTabValue("customNotification");
                              }, 100);
                            }
                          }, 100);
                        }}
                        underline="hover"
                      >
                        View notification setup guide
                      </Link>
                    </Typography>
                  </AccordionDetails>
                </Accordion>

                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography><Chip size="small" label="New" color="success" sx={{ mr: 1 }} /> Job Audit Trail</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>
                      Track who changed what and when with the new Audit Trail feature. This provides complete visibility into job modifications, helping you maintain accountability and troubleshoot issues.
                      <p></p>
                      Click the Audit Trail icon in the job list to view the complete history of changes.
                    </Typography>
                  </AccordionDetails>
                </Accordion>

                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography><Chip size="small" label="New" color="success" sx={{ mr: 1 }} /> Archived Jobs View</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>
                      Deleted jobs are no longer gone forever. Access them through the new Archived Jobs tab in the Jobs View. You can see who deleted each job and when by checking the Audit Trail.
                    </Typography>
                  </AccordionDetails>
                </Accordion>

                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography><Chip size="small" label="New" color="success" sx={{ mr: 1 }} /> Failed Jobs View</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>
                      Quickly identify and troubleshoot issues with the new Failed Jobs tab. This dedicated view makes it easier to monitor and resolve job failures without having to filter through all your jobs.
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              </Box>

              {/* Version 2.1 */}
              <Box sx={{ mb: 3, p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                <Typography variant="h6" sx={{ mb: 1 }}>
                  Version 2.1
                </Typography>
                <Typography variant="caption" display="block" sx={{ mb: 2 }}>
                  Released: March 10, 2023
                </Typography>

                <Typography variant="body2">
                  <ul>
                    <li><strong>Region selection</strong> - Choose your preferred region during setup</li>
                  </ul>
                  <Link href="#" underline="hover" sx={{ mt: 1, display: 'block' }}>View regional deployment guide</Link>
                </Typography>
              </Box>

              {/* Version 2.0 */}
              <Box sx={{ mb: 3, p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                <Typography variant="h6" sx={{ mb: 1 }}>
                  Version 2.0
                </Typography>
                <Typography variant="caption" display="block" sx={{ mb: 2 }}>
                  Released: November 5, 2022
                </Typography>

                <Typography variant="body2">
                  <ul>
                    <li><strong>Job failure notifications</strong> - Receive email alerts when jobs fail</li>
                    <li><strong>Enhanced file handling</strong> - New Append and Flush and Append options for File Specification Templates</li>
                    <li><strong>Custom port support</strong> - Connect to SFTP servers on non-standard ports</li>
                    <li><strong>Unique Identifier option</strong> - Specify unique identifiers for imports</li>
                  </ul>
                </Typography>
              </Box>

              {/* Version 1.0 */}
              <Box sx={{ p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                <Typography variant="h6" sx={{ mb: 1 }}>
                  Version 1.0
                </Typography>
                <Typography variant="caption" display="block" sx={{ mb: 2 }}>
                  Released: June 15, 2022
                </Typography>

                <Typography variant="body2">
                  <p>Initial release with core SFTP functionality for importing and exporting contact lists and DNC lists.</p>
                  <p><strong>Key features:</strong></p>
                  <ul>
                    <li>Secure file transfers between your systems and SFTP servers</li>
                    <li>Support for both encrypted and non-encrypted files</li>
                    <li>PGP encryption for files uploaded to SFTP servers</li>
                    <li>Flexible scheduling options</li>
                  </ul>
                </Typography>
              </Box>
            </Box>
          )}
        </div>
      </div >
    </>
  );
};

export default ProtectedHelp;
